import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { axiosInstance, formatRupiah, isEmptyData, encodeValue } from "../../../utils/helper";
import { useSelector } from 'react-redux';
import { BCA_STATUS_CODE, MOBILE, apiUrlB2B, uniqueID, deliveryId } from '../../../utils/constants';
import useNavigation from '../../../hook/useNavigation';
import { LoaderIcon } from '../../../utils/svg';
import qs from 'qs';

function FooterAction({ orderDetails = null, handleGetOrderDetail = () => handleGetOrderDetail }) {
	const navigate = useNavigation();
	const user = useSelector((store) => store?.user);
  const tab = useSelector((store) => store?.order?.tab);
  const [isLoading, setIsLoading] = useState(false);

  const isHidden = tab === "pesanan" ? false : ['2']?.includes(orderDetails?.topup_status);

  const orderType = orderDetails?.request_post_datas?.availabilityName?.toLowerCase()
	const paymentData = useSelector((store) => store.payment);
  
  const handlePaymentStatusB2B = async () => {
		try {
			const url = `/payment/status`;
			const body = {
				paymentReferenceID: orderDetails?.payment_order_id,
			};
			const response = await axiosInstance.post(url, JSON.stringify(body), {
				baseURL: apiUrlB2B,
        headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${user?.token}`,
				},
        validateStatus: function (status) {
          // Anggap 409 bukan error
          return (status >= 200 && status < 300) || status === 409;
        },
			});
			return response?.data;
		} catch (error) {
			console.log('error: ', error);
		}
	};

  const handlePayNow = async () => {
		setIsLoading(true);

		const response = await handlePaymentStatusB2B();
		if (response?.responseCode === BCA_STATUS_CODE.BLOCKED) {
			handleGetOrderDetail();
      setIsLoading(false);
      return;
		}

		const isMobile = user?.device === MOBILE;
		if (isMobile) {
		  return navigate.push(`/payment-partner?transaction_id=${orderDetails?.payment_order_id}`);
		} else {
		  return window.parent.postMessage(
		    {
		      type: 'payment-partner',
		      data: {
		        transaction_id: `${orderDetails?.payment_order_id}`,
		      },
		    },
		    '*',
		  );
		}
	};

  const handleCompletePickup = async (id = null) => {
    if (isEmptyData(id)) return;
    try {
      setIsLoading(true);
			const url = `/orders/completed-pickup`;
			const body = {
        unquieid: uniqueID,
				order_id: id,
			};
			const res = await axiosInstance.post(url, JSON.stringify(body), {
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${user?.token}`,
				},
			});
      if (res?.status === 200) {
        handleGetOrderDetail(); 
      }
      setIsLoading(false);
    } catch (error) {
      console.log('error: ', error);
      setIsLoading(false);
    }
  }

	const handlePayNowBRI = async () => {
		setIsLoading(true);

		if (paymentData.status !== "EXPIRED") {
			window.location.href = orderDetails?.redirect_payment_url;
		}

		setIsLoading(false);
	};

	const handleRemoveCart = async () => {
		try {
			const postData = {
				unquieid: uniqueID,
				customerID: encodeValue(user?.customerID),
			};
			const res = await axiosInstance.post(`cart/removeCart`, qs.stringify(postData));
			return res;
		} catch (error) {
			console.log('error: ', error);
		}
	};

	const handleOrderAgain = async (item) => {
		try {
			const removeCart = await handleRemoveCart();
			if (removeCart?.data?.status !== 'ok') {
				return;
			}

			const postData = {
				unquieid: uniqueID,
				customerID: encodeValue(user?.customerID),
				orderID: encodeValue(item?.order_primary_id),
        availabilityID: deliveryId,
			};
			const res = await axiosInstance.post(`orders/orderAgain`, qs.stringify(postData));
			if (res?.data?.status === 'ok') {
				navigate.push('/summary');
			}
		} catch (error) {
			console.log('error: ', error);
		}
	};

  return (
		<div className={`w-full px-4 py-2 fixed max-w-3xl bottom-0 bg-white z-[6] ${isHidden && 'hidden'}`}>
			{(orderDetails?.orderStatus === '1' || orderDetails?.orderStatus === '2' || orderDetails?.orderStatus === '3') && (
				<div className=''>
					<Link to='/' className='w-full button text-sm font-semibold !text-[var(--rose-violet)] border-[var(--rose-violet)] !py-3 hover:!bg-white hover:!border-[var(--rose-violet)] !bg-white'>
						Kembali ke Beranda UFood
					</Link>
				</div>
			)}
			{(orderDetails?.orderStatus === '4' || orderDetails?.orderStatus === '5') && (
				<button className='w-full button text-sm font-semibold mt-0' onClick={() => handleOrderAgain(orderDetails)}>
					Reorder
				</button>
			)}
			{orderType === 'pickup' && orderDetails?.orderStatus === '13' && (
				<button id='order_history_reorder_detail' className='w-full button text-sm font-semibold mt-0 bg-[var(--rose-violet)] border-[var(--rose-violet)] hover:bg-[var(--rose-violet)]' onClick={() => handleCompletePickup(orderDetails?.order_primary_id)}>
					{isLoading ? (
						<div className='flex justify-center items-center w-full'>
							<LoaderIcon />
						</div>
					) : (
						'Sudah Diambil'
					)}
				</button>
			)}
			{orderDetails?.orderStatus === '0' && user?.is_b2b && user?.companyName?.toLowerCase() === "bca" && (
				<div
					onClick={() => {
						if (isLoading) return;
						handlePayNow();
					}}
					className={`mt-2 w-full bg-[var(--rose-violet)] text-white flex justify-between font-normal text-sm p-3 border-0 items-center rounded-md ${isLoading && 'opacity-50'}`}>
					{isLoading ? (
						<div className='flex justify-center items-center w-full'>
							<LoaderIcon />
						</div>
					) : (
						<>
							<span>Pay Now</span>
							<span className='text-sm'>{formatRupiah(orderDetails?.totalAmount)}</span>
						</>
					)}
				</div>
			)}

			{orderDetails?.orderStatus === '0' && user?.is_b2b && user?.companyName?.toLowerCase() === "bri" && !isEmptyData(orderDetails?.redirect_payment_url) && (
				<div
					onClick={() => {
						if (isLoading) return;
						handlePayNowBRI();
					}}
					className={`mt-2 w-full bg-[var(--rose-violet)] text-white flex justify-between font-normal text-sm p-3 border-0 items-center rounded-md ${isLoading && 'opacity-50'}`}>
					{isLoading ? (
						<div className='flex justify-center items-center w-full'>
							<LoaderIcon />
						</div>
					) : (
						<>
							<span>Bayar dan Pesan</span>
							<span className='text-sm'>{formatRupiah(orderDetails?.totalAmount)}</span>
						</>
					)}
				</div>
			)}
		</div>
  );
}

export default FooterAction;
